// document.querySelectorAll('.video-wrapper').forEach(container => {
//   const video = container.querySelector('.ugc-slide-video video');
//   const playButton = container.querySelector('.play-btn');

//   // Pausa el video al cargar
//   video.pause();

//   // Evento al hacer clic en el botón de reproducción
//   playButton.addEventListener('click', () => {
//       console.log('playButton clicked');
//       video.play();
//       video.setAttribute('controls', 'controls'); // Muestra controles de video
//       playButton.classList.add('hidden'); // Oculta el botón de reproducción
//   });

//   // Opcional: muestra el botón nuevamente al pausar 
//   video.addEventListener('pause', () => {
//       playButton.classList.remove('hidden');
//       video.removeAttribute('controls'); // Oculta controles al pausar
//   });
// }); 

document.addEventListener('DOMContentLoaded', () => {
  initVideoWrappers();

  // (Opcional) Si tu tema inyecta contenido dinámico (Quick Add, AJAX, etc.),
  // esto engancha nuevos .video-wrapper que aparezcan después.
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.('.video-wrapper')) setupVideoWrapper(n);
        n.querySelectorAll?.('.video-wrapper').forEach(setupVideoWrapper);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
});

function initVideoWrappers(root = document) {
  root.querySelectorAll('.video-wrapper').forEach(setupVideoWrapper);
}

function setupVideoWrapper(container) {
  if (container.__videoSetup) return;

  const video = container.querySelector('video');
  const playButton = container.querySelector('.play-btn');
  if (!video || !playButton) return;

  try { video.pause(); } catch (e) {}

  // Estado para controlar seeks y pausas "transitorias"
  let isSeeking = false;
  let wasPlayingBeforeSeek = false;
  let pauseTimer = null;

  // Play al dar clic
  playButton.addEventListener('click', () => {
    const p = video.play();
    if (p && p.then) p.catch(err => console.warn('[video] play() bloqueado:', err));
    video.setAttribute('controls', 'controls');
    playButton.classList.add('hidden');
  });

  // Asegura UI coherente cuando entra a play por cualquier vía
  video.addEventListener('play', () => {
    video.setAttribute('controls', 'controls');
    playButton.classList.add('hidden');
  });

  // Durante el seek: recuerda estado y no dispares UI de pausa
  video.addEventListener('seeking', () => {
    isSeeking = true;
    wasPlayingBeforeSeek = !video.paused;
    video.setAttribute('controls', 'controls');
    clearTimeout(pauseTimer);
  });

  // Al terminar el seek: reanuda si estaba reproduciendo
  video.addEventListener('seeked', () => {
    const shouldResume = wasPlayingBeforeSeek;
    isSeeking = false;
    wasPlayingBeforeSeek = false;
    if (shouldResume) video.play().catch(() => {});
  });

  // Pausa "real": muestra overlay y quita controles (no durante seek)
  video.addEventListener('pause', () => {
    if (isSeeking) return;
    clearTimeout(pauseTimer);
    pauseTimer = setTimeout(() => {
      if (!isSeeking && video.paused) {
        playButton.classList.remove('hidden');
        video.removeAttribute('controls');
      }
    }, 120);
  });

  // Al terminar el video
  video.addEventListener('ended', () => {
    playButton.classList.remove('hidden');
    video.removeAttribute('controls');
  });

  // Si está dentro de <details>, resetea al cerrar
  const details = container.closest('details');
  if (details) {
    details.addEventListener('toggle', () => {
      if (!details.open) {
        try { video.pause(); } catch (e) {}
        video.currentTime = 0;
        video.removeAttribute('controls');
        playButton.classList.remove('hidden');
      }
    });
  }

  container.__videoSetup = true;
}


// function setupVideoWrapper(container) {
//   if (container.__videoSetup) return; // evita duplicados

//   // Busca el video de forma genérica (sirve para tu slide y para el acordeón)
//   const video = container.querySelector('video');
//   const playButton = container.querySelector('.play-btn');

//   if (!video || !playButton) return;

//   // Pausa al inicio
//   try { video.pause(); } catch (e) {}

//   // Play al dar clic
//   playButton.addEventListener('click', () => {
//     console.log('[video] playButton clicked');
//     const p = video.play();
//     if (p && typeof p.then === 'function') {
//       p.catch(err => console.warn('[video] play() bloqueado:', err));
//     }
//     video.setAttribute('controls', 'controls');
//     playButton.classList.add('hidden');
//   });

//   // Si se pausa manualmente, vuelve a mostrar el botón y oculta controles
//   video.addEventListener('pause', () => {
//     playButton.classList.remove('hidden');
//     video.removeAttribute('controls');
//   });

//   // Si está dentro de un <details>, pausa y resetea al cerrar el acordeón
//   const details = container.closest('details');
//   if (details) {
//     details.addEventListener('toggle', () => {
//       if (!details.open) {
//         try { video.pause(); } catch (e) {}
//         video.currentTime = 0;
//         video.removeAttribute('controls');
//         playButton.classList.remove('hidden');
//       }
//     });
//   }

//   container.__videoSetup = true;
// }
